import {
  ExternalChatUser,
  isExternalChatUser,
} from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { useDocumentsOnceStore } from "Helpers/StoreHelper";
import { firestore } from "firebase/app";
import { useRef } from "react";

export function useUsersOnceStore(
  organizationId: string,
  userIds: string[]
) {
  const collectionRef = useRef(
    firestore()
      .collection(CollectionPath.ORGANIZATIONS)
      .doc(organizationId)
      .collection(CollectionPath.USERS)
  );

  return useDocumentsOnceStore<ExternalChatUser>({
    collection: collectionRef.current,
    documentPaths: userIds,
    is: isExternalChatUser,
  });
}
